import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const MetadataForm = ({ 
  formData, 
  setFormData, 
  uploading, 
  defaultFileName 
}) => {
  const updateField = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="space-y-4 border-t border-gray-700 pt-4">
      <h3 className="text-white font-semibold">Content Details</h3>
      
      {/* Title */}
      <div className="space-y-2">
        <Label htmlFor="title" className="text-white">Title</Label>
        <Input
          id="title"
          value={formData.title}
          onChange={(e) => updateField('title', e.target.value)}
          placeholder={defaultFileName || 'Enter title'}
          className="bg-gray-800 border-gray-600 text-white"
          disabled={uploading}
          data-testid="upload-title-input"
        />
      </div>

      {/* Description */}
      <div className="space-y-2">
        <Label htmlFor="description" className="text-white">Description</Label>
        <Textarea
          id="description"
          value={formData.description}
          onChange={(e) => updateField('description', e.target.value)}
          placeholder="Describe your content..."
          className="bg-gray-800 border-gray-600 text-white"
          disabled={uploading}
          rows={3}
          data-testid="upload-description-input"
        />
      </div>

      {/* Genre and Visibility */}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="genre" className="text-white">Genre/Category</Label>
          <Input
            id="genre"
            value={formData.genre}
            onChange={(e) => updateField('genre', e.target.value)}
            placeholder="e.g., Music, Action"
            className="bg-gray-800 border-gray-600 text-white"
            disabled={uploading}
            data-testid="upload-genre-input"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="visibility" className="text-white">Visibility</Label>
          <Select
            value={formData.visibility}
            onValueChange={(value) => updateField('visibility', value)}
            disabled={uploading}
          >
            <SelectTrigger 
              className="bg-gray-800 border-gray-600 text-white"
              data-testid="upload-visibility-select"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-gray-800 border-gray-700">
              <SelectItem value="public" className="text-white">Public</SelectItem>
              <SelectItem value="private" className="text-white">Private</SelectItem>
              <SelectItem value="subscribers" className="text-white">Subscribers Only</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Tags */}
      <div className="space-y-2">
        <Label htmlFor="tags" className="text-white">Tags (comma-separated)</Label>
        <Input
          id="tags"
          value={formData.tags}
          onChange={(e) => updateField('tags', e.target.value)}
          placeholder="e.g., music, urban, culture"
          className="bg-gray-800 border-gray-600 text-white"
          disabled={uploading}
          data-testid="upload-tags-input"
        />
      </div>
    </div>
  );
};

export default MetadataForm;
